<pr-input-map
  (placeChanged)="toValue = $event"
  placeholder="Enter to address..."
  label="Saisissez l’adresse de votre résidence principale"
  formGroupName="address"
  [isGMaps]="!isSwisslifeProduct"
  [isSwisslifeProduct]="isSwisslifeProduct"
  [countries]="countries"
  [derrors]="derrors"
  [isDefault]="false"
>
</pr-input-map>
